import { useAuth0 } from '@auth0/auth0-react'
import { useMutation, UseMutationOptions, useQuery, UseQueryResult } from '@tanstack/react-query'
import { Consent, ConsentId } from './types'
import { getConsent, postConsent } from './consent'
import { QueryKeys } from '../../types'

export const useConsentMutation = (options?: UseMutationOptions<Response, Error, ConsentId>) => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationFn: async (consentId?: ConsentId) => {
      const accessToken = await getAccessTokenSilently()
      if (!consentId) throw new Error('Missing required consentId')
      return await postConsent({ accessToken, consentId })
    },
    ...options,
  })
}

export const useGetUsersConsent = (consentId: ConsentId): UseQueryResult<Consent, Error> => {
  const { getAccessTokenSilently } = useAuth0()
  return useQuery({
    queryKey: [QueryKeys.Consent, consentId, 'private'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getConsent({ consentId, accessToken })
    },
    retry: false,
  })
}
